<div class="row" id="subnav">
  <div class="col">
    @if (marketList) {
      <span class="float-left">
        <span class="fas fa-map-marker-alt"></span>
        @if (marketList?.length > 1) {
          <select #mkt [ngModel]="market ? market.sourceKey : null" (change)="selectedMarketChanged(mkt.value)">
            @for (market of marketList; track market) {
              <option [value]="market.sourceKey">{{market.orgName}} {{market.sourceKey}}</option>
            }
          </select>
        }
        @if (marketList?.length === 1) {
          <span>{{market.orgName}} {{market.sourceKey}}</span>
        }
      </span>
    }
    @if (displayName) {
      <span class="float-right">
        <span class="bell-icon mr-3"
              (click)="openNotificationSidebar()">
          <i class="fas fa-bell"></i>
          @if (userHasNotices()) {
          <i severity="danger" pBadge></i>
          }
        </span>
        <i class="fas fa-user"></i> <a routerLink="/profile">{{displayName}}</a>
      </span>
    }
  </div>
</div>
